import { useEffect, useState } from 'react';

// Braille CLI spinner (⠋⠙⠹…) for loading states.
const FRAMES = ['⠋', '⠙', '⠹', '⠸', '⠼', '⠴', '⠦', '⠧', '⠇', '⠏'];

export default function Spinner({ label = 'loading' }) {
  const [i, setI] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setI((n) => (n + 1) % FRAMES.length), 80);
    return () => clearInterval(id);
  }, []);
  return (
    <span className="inline-flex items-center gap-2 text-sm text-muted-foreground">
      <span className="w-3 text-primary">{FRAMES[i]}</span>
      {label}
    </span>
  );
}
